import { render, staticRenderFns } from "./ContentOnlyBlock.vue?vue&type=template&id=3b93d823"
import script from "./ContentOnlyBlock.vue?vue&type=script&lang=js"
export * from "./ContentOnlyBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentOnlyBlock.vue?vue&type=style&index=0&id=3b93d823&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b93d823')) {
      api.createRecord('3b93d823', component.options)
    } else {
      api.reload('3b93d823', component.options)
    }
    module.hot.accept("./ContentOnlyBlock.vue?vue&type=template&id=3b93d823", function () {
      api.rerender('3b93d823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/contents/ContentOnlyBlock.vue"
export default component.exports